const ALL_REPORT_STATUS = ['New', 'Downloaded', 'Reviewed', 'Interpreted', 'Signed', 'Completed'];

export { ALL_REPORT_STATUS };
